import { atom } from "jotai";
import { NLUSocket } from "@/core/socket";

export const socketAtom = atom<NLUSocket>();
